var m = require('mithril');
var flash = require('../../components/flash');

function getErrors(state) {
  return state && Array.isArray(state.errors) ? state.errors : [];
}

function columnModalView (newColumn, state) {
  return m("form", {role:"form"}, [
    m(flash, {items: getErrors(state), bg: 'bg-red'}),
    m("div", {class:"form-group"}, [
      m("div", "Name"),
      m("input.form-control", {
        type:"text", 
        autocomplete: 'off',
        oninput: function(ev) {
          newColumn.name = ev.target.value;
          if (state && getErrors(state).length && String(newColumn.name || '').trim()) {
            state.errors = [];
          }
        },
        value: newColumn.name,
      })
    ])
  ]);
}

module.exports = columnModalView;
